<app-common-page-title icon="assets/playbison/icon-missions-home.svg"><ng-container i18n>Bison Missions</ng-container></app-common-page-title>

<div *ngIf="isLoading && !isServer else missions">
  <app-inner-loader></app-inner-loader>
</div>

<ng-template #missions>
  <div class="category-menu" fxLayout="row" fxLayoutGap="8px">
    <div class="category active" [class.active]="status==='all'" (click)="filterTour('all')"><img src="{{licenceService.getKey('icon-mission-home')}}"/><p i18n>All</p></div>
    <div class="category" [class.active]="status===0" (click)="filterTour(0)"><img src="{{licenceService.getKey('batch-icon-mission')}}"/><p i18n>Active</p></div>
    <div class="category" [class.active]="status===1" (click)="filterTour(1)"><img src="{{licenceService.getKey('batch-icon-schedule')}}"/><p i18n>Upcoming</p></div>
  </div>
  <div fxLayout="row wrap" class="card-container">
    <ng-container *ngFor="let item of tournments; let index=index">
      <app-home-page-mission-card [routeURL]="missionsTrx" [isLarge]="index" [mission]="item" [isEmbedded]="false" [tournamentIndex]="index"></app-home-page-mission-card>
    </ng-container>
  </div>
</ng-template>